import ReactHighcharts from 'react-highcharts'
import * as ReactHighmaps from 'react-highcharts/ReactHighmaps'

let hasBeenInitialized = false

function initHighcharts() {
  if (!hasBeenInitialized) {
    ReactHighmaps.Highcharts.setOptions({
      lang: {
        thousandsSep: ','
      }
    })
    hasBeenInitialized = true
  }
}

export { initHighcharts }



// WEBPACK FOOTER //
// ./src/app/containers/App/HighchartsInit.ts